import React, { createContext, useState, useEffect } from "react";
import axios from "axios";
import { jwtDecode } from "jwt-decode";

const UserDataContext = createContext();

export const UserDataProvider = ({ children }) => {
  // const [profileMenuName, setProfileMenuName] = useState(null);
  // const [profileImage, setProfileImage] = useState(null);

  const [profileMenuName, setProfileMenuName] = useState(() => {
    return localStorage.getItem("profileMenuName")
      ? JSON.parse(localStorage.getItem("profileMenuName"))
      : null;
  });
  const [profileImage, setProfileImage] = useState(() => {
    return localStorage.getItem("profileImage")
      ? JSON.parse(localStorage.getItem("profileImage"))
      : null;
  });

  const [loader, setLoader] = useState(true);
  const token = localStorage.getItem("token");
  const decode = jwtDecode(token);

  const fetchViewUsersData = async () => {
    axios({
      method: "post",
      url: `${process.env.REACT_APP_SERVER}recruiter/viewUsers`,
      data: { id: decode.user_id },
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    })
      .then((response) => {
        if (response.data.status === true) {
          const newProfileMenuName = response.data.data;
          const newProfileImage = response.data.settings;

          setProfileMenuName(newProfileMenuName);
          // setProfileImage(newProfileImage);
          localStorage.setItem("profileMenuName", JSON.stringify(newProfileMenuName));
          localStorage.setItem("profileImage", JSON.stringify(newProfileImage));
        }
        setLoader(false);
      })
      .catch((error) => {
        setLoader(false);
        console.error(error);
      });
  };

  useEffect(() => {
    const role = decode.role;
    if (
      ["ADMIN", "SUBCONTRACT", "FREELANCER", "SUBVENDOR"].includes(role) &&
      (!profileMenuName || !profileImage)
    ) {
      fetchViewUsersData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <UserDataContext.Provider
      value={{
        profileMenuName,
        profileImage,
        loader,
        setProfileMenuName,
        setProfileImage,
        setLoader,
        fetchViewUsersData,
      }}
    >
      {children}
    </UserDataContext.Provider>
  );
};

export const useUserDetails = () => React.useContext(UserDataContext);
